import { Product } from './product';
import { Customer } from './customer';
import { CustomerPaymentMethod } from './customer-payment-method';
import { ProvisioningParameter } from './provisioning-parameter';
import { Discount } from "./discount";

export class CheckoutData {
  private _id: string;
  private sellerId: string;
  private buyerFullName: string;
  private buyerCompanyLegalName: string;
  private buyerCompanyName: string;
  private buyerCpf: string;
  private buyerCnpj: string;
  private buyerBirthDate: string;
  private buyerEmail: string;
  private buyerPhoneNumber: string;
  private buyerAddressZipCode: string;
  private buyerAddressStreet: string;
  private buyerAddressNumber: string;
  private buyerAddressQuarter: string;
  private buyerAddressCity: string;
  private buyerAddressState: string;
  private product: Product;
  private paymentConditionIdentifier: string;
  private paymentMethodIdentifier: string;
  private paymentMethodCreditCardInformationNumber: string;
  private paymentMethodCreditCardInformationBrand: string;
  private paymentMethodCreditCardInformationHolder: string;
  private paymentMethodCreditCardInformationExpirationDate: string;
  private paymentMethodCreditCardInformationSecurity: string;
  private provisioningParameter: ProvisioningParameter;
  private discounts: Array<Discount>;
  private validationData: any;
  private sameCard: boolean;
  private nickname: string;
  private defaultCard: boolean;
  private accountPaymentDataId: string;

  private oneClick: boolean;
  private purchaseOrigin: string;

  //Adyen
  private isAdyen: boolean;
  private paymentMethodCreditCardInformationEncryptedCardNumber: string;
  private paymentMethodCreditCardInformationEncryptedCardValidityMonth: string;
  private paymentMethodCreditCardInformationEncryptedCardValidityYear: string;
  private paymentMethodCreditCardInformationEncryptedCardSecurityCode: string;

  //Disconnected Sale
  private isDisconnectedSale: boolean;
  isDelendSale: boolean;

  constructor(product: Product,
    discounts: Array<Discount>,
    customerData: Customer,
    paymentMethod: CustomerPaymentMethod,
    sellerId: string,
    salesChannel: string,
    cartId?: string,
    validationData?: any,
    isDisconnectedSale?: any) {

    this._id = cartId;
    this.sellerId = sellerId;
    this.product = product;
    this.buyerFullName = customerData.name;
    this.buyerCompanyLegalName = customerData.companyLegalName;
    this.buyerCompanyName = customerData.companyName;
    this.buyerCpf = customerData.cpf.replace(/[^0-9]/g, '');
    this.buyerCnpj = customerData.cnpj.replace(/[^0-9]/g, '');
    this.buyerBirthDate = customerData.birthDate;
    this.buyerEmail = customerData.email;
    this.buyerPhoneNumber = customerData.cellphone;
    this.buyerAddressZipCode = customerData.zipcode;
    this.buyerAddressStreet = customerData.street;
    this.buyerAddressNumber = customerData.number;
    this.buyerAddressQuarter = customerData.quarter;
    this.buyerAddressCity = customerData.city;
    this.buyerAddressState = customerData.state;
    this.paymentMethodIdentifier = paymentMethod ? paymentMethod.identifier : null;
    this.paymentConditionIdentifier = paymentMethod ? paymentMethod.paymentConditionIdentifier : null;
    this.paymentMethodCreditCardInformationNumber = paymentMethod ? paymentMethod.card.cardNumber : null;
    this.paymentMethodCreditCardInformationBrand = paymentMethod ? paymentMethod.card.brand : null;
    this.paymentMethodCreditCardInformationHolder = paymentMethod ? paymentMethod.card.cardHolder : null;
    this.paymentMethodCreditCardInformationExpirationDate = paymentMethod ? paymentMethod.card.cardValidityDate : null;
    this.paymentMethodCreditCardInformationSecurity = paymentMethod ? paymentMethod.card.cardSecurityCode : null;
    this.provisioningParameter = customerData.provisioningParameter;
    this.provisioningParameter.email = customerData.email;
    this.provisioningParameter.cellphone = customerData.cellphone;
    this.discounts = discounts?.map(discount => new Discount(discount)) ?? [];
    this.validationData = validationData || null;
    this.sameCard = paymentMethod.sameCard || null;
    this.provisioningParameter.salesChannel = salesChannel;
    this.provisioningParameter.platformAccess = customerData.provisioningParameter.platformAccess;
    this.nickname = paymentMethod.nickname || null;
    this.defaultCard = paymentMethod.defaultCard || null;
    this.accountPaymentDataId = paymentMethod.accountPaymentDataId || null;

    //Adyen
    this.isAdyen = paymentMethod ? paymentMethod.isAdyen : null;
    this.paymentMethodCreditCardInformationEncryptedCardNumber = paymentMethod?.card?.encryptedCardNumber;
    this.paymentMethodCreditCardInformationEncryptedCardValidityMonth = paymentMethod && paymentMethod.card.encryptedCardValidityMonth ? paymentMethod.card.encryptedCardValidityMonth : null;
    this.paymentMethodCreditCardInformationEncryptedCardValidityYear = paymentMethod && paymentMethod.card.encryptedCardValidityYear ? paymentMethod.card.encryptedCardValidityYear : null;
    this.paymentMethodCreditCardInformationEncryptedCardSecurityCode = paymentMethod && paymentMethod.card.encryptedCardSecurityCode ? paymentMethod.card.encryptedCardSecurityCode : null;

    this.purchaseOrigin = sessionStorage.getItem('purchaseOrigin');
    this.isDelendSale = sessionStorage.getItem('isDelend') === 'true';
    this.oneClick = this.purchaseOrigin === 'oneClickPurchase' ? true : false;

    this.isDisconnectedSale = isDisconnectedSale;
  }

  getInSaleRequestFormat() {

    const additionalData = JSON.parse(sessionStorage.getItem('additionalData')) || '{}';

    // Remove o parametro de salvar cartão caso o método de pagamento não seja cartão
    if (this.paymentMethodIdentifier !== "CREDIT_CARD") {
      delete additionalData.saveCreditCard;
    }

    let logon = sessionStorage.getItem('logon') || null;
    let distributor = sessionStorage.getItem('distributor') || null;


    const data = {
      '_id': this._id,
      'seller': {
        '_id': this.sellerId
      },
      'buyer': {
        'name': this.buyerFullName,
        'legalName': this.buyerCompanyLegalName,
        'companyName': this.buyerCompanyName,
        'cpf': this.buyerCpf,
        'cnpj': this.buyerCnpj,
        'birthDate': this.buyerBirthDate,
        'email': this.buyerEmail,
        'emailConfirmation': this.buyerEmail,
        'phoneNumber': this.buyerPhoneNumber.trim().replace(/[^0-9]/g, ''),
        'address': {
          'zipCode': this.buyerAddressZipCode,
          'street': this.buyerAddressStreet,
          'number': this.buyerAddressNumber,
          'quarter': this.buyerAddressQuarter,
          'city': this.buyerAddressCity,
          'state': this.buyerAddressState
        }
      },
      'product': this.product,
      'appliedCoupons': this.discounts,
      'provisioningParameters': {
        'businessId': this.provisioningParameter.businessId,
        'userId': this.provisioningParameter.userId,
        'phoneNumber': this.provisioningParameter.cellphone.trim().replace(/[^0-9]/g, ''),
        'email': this.provisioningParameter.email,
        'allowAutomaticRecharge': this.provisioningParameter.allowAutomaticRecharge,
        'salesChannel': this.provisioningParameter.salesChannel,
        'platformAccess': this.provisioningParameter.platformAccess,
        'logon': logon,
        'distributor': distributor
      },
      'paymentMethod': {
        'identifier': this.paymentMethodIdentifier,
        'creditCardInformation': null,
        'isAdyen': this.isAdyen
      },
      'paymentConditionIdentifier': null,
      'validationData': this.validationData,
      'additionalData': additionalData,
      'oneClick': this.oneClick,
      'isDisconnectedSale': this.isDisconnectedSale,
      'purchaseOrigin': this.purchaseOrigin,
      'isDelendSale': this.isDelendSale
    };

    if (this.paymentMethodIdentifier === 'CREDIT_CARD') {
      data.paymentMethod.creditCardInformation = {
        'number': this.paymentMethodCreditCardInformationEncryptedCardNumber ? this.paymentMethodCreditCardInformationNumber : this.maskCreditCardNumber(this.paymentMethodCreditCardInformationNumber),
        'brand': this.paymentMethodCreditCardInformationBrand,
        'holder': this.paymentMethodCreditCardInformationHolder,
        'expirationMonth': this.getExpirationMonth(),
        'expirationYear': this.getExpirationYear(),
        'cardToken': null,
        'sameCard': this.sameCard,
        'nickname': this.nickname,
        'defaultCard': this.defaultCard,
        "accountPaymentDataId": this.accountPaymentDataId,

        'isAdyen': this.isAdyen,
        "encryptedCardNumber": this.paymentMethodCreditCardInformationEncryptedCardNumber,
        "encryptedExpirationMonth": this.paymentMethodCreditCardInformationEncryptedCardValidityMonth,
        "encryptedExpirationYear": this.paymentMethodCreditCardInformationEncryptedCardValidityYear,
        "encryptedSecurityCode": this.paymentMethodCreditCardInformationEncryptedCardSecurityCode
      };

      data.paymentConditionIdentifier = this.paymentConditionIdentifier;
    }

    return data;
  }

  private getExpirationMonth() {
    if (this.paymentMethodCreditCardInformationExpirationDate) {
      const expirationMonth = this.paymentMethodCreditCardInformationExpirationDate.split('/')[0];
      if (expirationMonth.length === 1) {
        return '0' + expirationMonth;
      } else {
        return expirationMonth;
      }
    } else {
      return '';
    }
  }

  private getExpirationYear() {
    if (this.paymentMethodCreditCardInformationExpirationDate) {
      const expirationYear = this.paymentMethodCreditCardInformationExpirationDate.split('/')[1];
      return '20' + expirationYear;
    } else {
      return '';
    }
  }


  private maskCreditCardNumber(cardNumber: string): string {
    const unmaskedValue = cardNumber.substr(cardNumber.length - 4, 4);
    let maskedValue = cardNumber.substr(0, cardNumber.length - 4);
    maskedValue = maskedValue.split(' ').map(
      digitGroup => {
        let maskedGroup = '';
        while (maskedGroup.length < digitGroup.length) {
          maskedGroup += '*';
        }
        return maskedGroup;
      }
    ).join(' ');
    return maskedValue + unmaskedValue;
  }
}
